module.exports = __webpack_public_path__ + "img/shiba-body-level5.f46ec51f.png";